
import axios from "axios";
export const clientHTTP = axios.create({
    baseURL: "https://donateursapis.caritasbenin.org" 
  })